import { render, staticRenderFns } from "./scm-data.vue?vue&type=template&id=79dac3ce"
import script from "./scm-data.vue?vue&type=script&lang=js"
export * from "./scm-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports